export class DomService {
	constructor() {}

	/**
	 * @deprecated use native JS: element.closest(selectors)
	 */
	Closest(el, selector) {
		var matchesFn;
		var parent;

		// find vendor prefix
		[
			"matches",
			"webkitMatchesSelector",
			"mozMatchesSelector",
			"msMatchesSelector",
			"oMatchesSelector",
		].some(function (fn) {
			if (typeof document.body[fn] == "function") {
				matchesFn = fn;
				return true;
			}
			return false;
		});

		if (el[matchesFn](selector)) return el;

		// traverse parents
		while (el) {
			parent = el.parentNode;
			if (parent && parent[matchesFn](selector)) {
				return parent;
			}
			el = parent;
			if (el.tagName === "HTML") break;
		}

		return null;
	}

	/**
	 * @param {Object} element HTML element
	 * @return {Array} siblings
	 */
	GetDOMSiblingElements(element) {
		// for collecting siblings
		let siblings = [];
		// if no parent, return no sibling
		if (!element.parentNode) {
			return siblings;
		}
		// first child of the parent node
		let sibling = element.parentNode.firstChild;
		// collecting siblings
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== element) {
				siblings.push(sibling);
			}
			sibling = sibling.nextSibling;
		}
		return siblings;
	}

	/**
	 * @deprecated - use BrowserSpecific.isIE()
	 */
	IE() {
		var undef,
			v = 3,
			div = document.createElement("div"),
			all = div.getElementsByTagName("i");

		while (
			((div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->"),
			all[0])
		);

		if (v === 9) document.body.classList.add("is-ie9");

		return v > 4 ? v : undef;
	}

	/**
	 * @deprecated - use BrowserSpecific.isIE11()
	 */
	IE11() {
		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
		return isIE11;
	}
}

export let domService = new DomService();
